export const GOOD_SALARY = 'goodSalary';
export const LOW_SALARY = 'lowSalary';
